var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconMenu11 = function SvgIconMenu11(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC600",
    d: "M7.984 9.016v13.968H16V25H7.984c-.53 0-1-.203-1.406-.61a2.011 2.011 0 0 1-.562-1.406V9.016c0-.532.187-1 .562-1.407C6.984 7.203 7.453 7 7.984 7H16v2.016H7.984Zm13.032 1.968L25.984 16l-4.968 5.016-1.407-1.453 2.578-2.579H12.017v-1.968h10.171L19.61 12.39l1.407-1.407Z"
  })));
};
export default SvgIconMenu11;